<template>
  <b-card no-body>
    <b-card-header>
      <b-card-title> کاربران ترم ها</b-card-title>
    </b-card-header>
    <!-- <div class="d-flex px-0 flex-wrap align-items-center">
      <b-form-group
        class="mb-1 col-12 col-sm-4 pr-md-2 px-0"
        label="فیلتر بر اساس"
      >
        <select-box
          v-model="course_id"
          label="text"
          class="w-100"
          select="id"
          url="course"
          searchable
        />
      </b-form-group>
    </div> -->
    <div v-if="loading" class="m-2">
      <b-skeleton width="100%" height="350px"></b-skeleton>
    </div>
    <b-card-body v-else class="d-flex justify-content-center w-100 p-0">
      <vue-apex-charts
        style="overflow-x: auto"
        id="revenue-report-chart"
        type="bar"
        height="400"
        width="1000"
        :options="chartOptions"
        :series="series"
      />
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard,
  BSkeleton,
  BFormInput,
  BFormGroup,
  BCardBody,
  BCardHeader,
  BCardTitle,
} from "bootstrap-vue";
import VueApexCharts from "vue-apexcharts";
import { $themeColors } from "@themeConfig";
import SelectBox from "@core/components/select-box/SelectBox.vue";
import qs from "qs";

export default {
  components: {
    VueApexCharts,
    BCard,
    BSkeleton,
    SelectBox,
    BFormInput,
    BFormGroup,
    BCardBody,
    BCardTitle,
    BCardHeader,
  },
  data() {
    return {
      course_id: "",
      series: [
        {
          name: "کابران",
          data: [],
        },
        {
          name: "کابران یونیک",
          data: [],
        },
      ],
      chartOptions: {
        chart: {
          stacked: false,
          type: "bar",
          toolbar: { show: false },
        },
        grid: {
          padding: {
            // bottom: -50,
            left: -10,
          },
          yaxis: {
            lines: { show: true },
          },
        },
        xaxis: {
          type: "category",
          categories: [],
          labels: {
            show: true,
          },
          axisTicks: {
            show: false,
          },
          axisBorder: {
            show: true,
          },
        },
        legend: {
          show: false,
        },
        dataLabels: {
          enabled: false,
        },
        colors: [$themeColors.primary, $themeColors.warning, $themeColors.info],
        plotOptions: {
          bar: {
            horizontal: true,
            columnWidth: "17%",
            borderRadius: 3,
          },
          distributed: true,
        },
        yaxis: {
          labels: {
            offsetX: -110,
            style: {
              colors: "#6E6B7B",
              fontSize: "0.86rem",
              fontFamily: "Montserrat",
            },
          },
        },
      },
      statistics: {},
      loading: false,
    };
  },
  created() {
    this.getstatistics();
  },
  watch: {
    course_id(val) {
      this.getstatistics();
    },
  },
  methods: {
    async getstatistics() {
      this.loading = true;
      try {
        const { data } = await this.$http.get("/panel/courses/statistics", {
          params: {
            filters: {
              course_id: this.course_id,
            },
          },
          paramsSerializer: (params) => {
            return qs.stringify(params);
          },
        });
        this.statistics = data.data[0];
        this.chartOptions.xaxis.categories = this.statistics.map(
          (x) => x.course.name
        );
        this.series[0].data = this.statistics.map((x) => x.all);
        this.series[1].data = this.statistics.map((x) => x.unique);
      } catch (e) {}
      this.loading = false;
    },
  },
};

// course_id
</script>
